<template>
  <v-container fluid>
    <!-- <v-card>
      <v-card-title class="text-h5">Dashboard</v-card-title>
    </v-card> -->
  </v-container>
</template>

<script>
import { layout } from "@/mixins";
export default {
  mixins: [layout],
  name: "AdminDashboard",

  components: {},

  data: () => ({
    theme: "admin",
  }),
  mounted() {
    this.$router.push("/admin/applications").catch(() => {});
  },
  methods: {},

  computed: {},
};
</script>